export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Estructuras',
      description: 'Diseñamos, calculamos y construimos estructuras seguras y duraderas para proyectos residenciales, comerciales e industriales. Nuestro equipo desarrolla soluciones estructurales eficientes que garantizan resistencia, estabilidad y cumplimiento de la normatividad vigente.',
      features: [
        'Diseño estructural',
        'Cálculo de estructuras',
        'Construcción con acero y concreto',
        'Supervisión estructural',
        'Reforzamiento y rehabilitación de estructuras'
      ]
    },
    {
      icon: 'ri-road-map-line',
      title: 'Obra Civil',
      description: 'Ejecutamos proyectos de obra civil con altos estándares de calidad, garantizando eficiencia en tiempos de ejecución y optimización de recursos. Realizamos desde obras pequeñas hasta desarrollos de mayor escala, cumpliendo siempre con las especificaciones técnicas y normativas.',
      features: [
        'Construcción de infraestructura',
        'Cimentaciones',
        'Pavimentación',
        'Banquetas y urbanización',
        'Obras hidráulicas y sanitarias'
      ]
    },
    {
      icon: 'ri-hammer-line',
      title: 'Terracerías',
      description: 'Realizamos trabajos de movimiento de tierras y preparación de terrenos, fundamentales para garantizar la estabilidad de cualquier proyecto de construcción. Contamos con personal especializado y maquinaria adecuada para realizar trabajos de nivelación y compactación con precisión.',
      features: [
        'Limpieza y desmonte de terreno',
        'Excavaciones',
        'Nivelación y conformación de plataformas',
        'Compactación de suelos',
        'Preparación de terrenos para construcción'
      ]
    },
    {
      icon: 'ri-eye-line',
      title: 'Ingeniería',
      description: 'Ofrecemos servicios de ingeniería y planeación técnica para garantizar que cada proyecto se desarrolle de manera eficiente, segura y rentable. Nuestro enfoque combina experiencia técnica con soluciones modernas para optimizar cada etapa del proyecto.',
      features: [
        'Desarrollo de proyectos ejecutivos',
        'Cálculo estructural',
        'Planeación y control de obra',
        'Supervisión técnica',
        'Consultoría en ingeniería'
      ]
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Renta de Maquinaria',
      description: 'Ponemos a disposición maquinaria especializada para construcción y movimiento de tierra, operada por personal capacitado o en modalidad de renta. Nuestro equipo permite optimizar tiempos de ejecución y mejorar la productividad en obra.',
      features: [
        'Excavadoras',
        'Retroexcavadoras',
        'Motoconformadoras',
        'Compactadores',
        'Equipo para movimiento de tierra'
      ]
    },
    {
      icon: 'ri-home-4-line',
      title: 'Viviendas',
      description: 'Desarrollamos proyectos de vivienda con diseño funcional, calidad constructiva y eficiencia en costos. Nos encargamos de todo el proceso, desde la planeación hasta la entrega final del proyecto.',
      features: [
        'Diseño y planeación de viviendas',
        'Construcción residencial',
        'Ampliaciones y remodelaciones',
        'Proyectos llave en mano',
        'Supervisión de obra'
      ]
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ofrecemos soluciones completas en el área de la construcción y desarrollo de infraestructura
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}